
/**
 * Utility functions for generating structured data for SEO
 */

export interface StructuredDataProps {
  title: string;
  description: string;
  imageUrl?: string;
  pageName?: string;
  isHomepage?: boolean;
  primaryLink?: string;
}

export const getStructuredData = ({
  title,
  description,
  imageUrl,
  pageName,
  isHomepage = false,
  primaryLink = ""
}: StructuredDataProps) => {
  const baseUrl = "https://joerg-hoermann.de";

  if (isHomepage) {
    // On homepage, LocalSEOStructuredData provides the LocalBusiness schema
    // and TechnicalSEOEnhancer provides the WebPage schema (with speakable)
    // so we return an empty array to avoid duplicates
    return [];
  }

  // Build breadcrumb for subpages
  let breadcrumbSchema = null;
  if (pageName) {
    breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Startseite",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": pageName,
          "item": `${baseUrl}${primaryLink || ""}`
        }
      ]
    };
  }

  // Subpages only get breadcrumb – LocalBusiness is provided once on the homepage
  // (via LocalSEOStructuredData) and referenced site-wide via @id.
  // Page-specific LocalBusiness (e.g. /coaching-nuernberg) is handled by
  // dedicated components to avoid duplicate schemas.
  return breadcrumbSchema 
    ? [breadcrumbSchema] 
    : [];
};
